import { worker } from "../mocks/browser";
import {
  setAccessToken,
  setUserInfoFromLocalStorage,
} from "../shared/utils/auth";
import { demoLoginDto } from "./mockData/user";
import { demoHandlers } from "./handlers";
import i18next from "i18next";

export async function initDemo(): Promise<void> {
  // 1. MSW worker 시작 + 데모 핸들러 등록 (기존 핸들러보다 우선)
  await worker.start({
    onUnhandledRequest: "bypass",
    serviceWorker: { url: "/mockServiceWorker.js" },
  });
  worker.use(...demoHandlers);

  // 2. 가짜 token + loginDto 주입 (기존 auth 체크 통과용)
  setAccessToken("demo-token");
  setUserInfoFromLocalStorage(demoLoginDto);

  // 3. ?lang= 파라미터로 언어 및 dir 설정
  const lang = new URLSearchParams(window.location.search).get("lang");
  if (lang && ["ko", "en", "ar"].includes(lang)) {
    await i18next.changeLanguage(lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute(
      "dir",
      lang === "ar" ? "rtl" : "ltr"
    );
  }
}
